import { render, staticRenderFns } from "./UserEmailPill.vue?vue&type=template&id=4de36ad4&scoped=true&"
import script from "./UserEmailPill.vue?vue&type=script&lang=ts&"
export * from "./UserEmailPill.vue?vue&type=script&lang=ts&"
import style0 from "./UserEmailPill.vue?vue&type=style&index=0&id=4de36ad4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de36ad4",
  null
  
)

export default component.exports